const GameStatus = {};

GameStatus.NONE = 0;
GameStatus.RUNNING = 1;
GameStatus.FINISH = 2;
GameStatus.END = 3;

export default GameStatus;